import React from "react";
import ReactDOM from "react-dom/client";

// Bootstrap primero: así el sistema de diseño propio (index.css y los estilos
// de cada componente) se carga después y gana los empates de especificidad.
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import "./index.css";
import App from "./App";

// Browser Router
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
